import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBlog } from '@common-types';
import { AppThunk } from '@share/utils';

export interface IBlogsState {
  blogs: IBlog[];
  loading: boolean;
  loadingBlog: boolean;
  error: string;
  errorBlog: string;
  selectedBlog: IBlog | null;
}

const initialState: IBlogsState = {
  blogs: [],
  loading: true,
  loadingBlog: true,
  error: '',
  errorBlog: '',
  selectedBlog: null,
};

const blogsSlice = createSlice({
  name: 'blogs',
  initialState,
  reducers: {
    setLoading: (state: IBlogsState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setLoadingBlog: (state: IBlogsState, { payload }: PayloadAction<boolean>) => {
      state.loadingBlog = payload;
    },
    setError: (state: IBlogsState, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },
    setErrorBlog: (state: IBlogsState, { payload }: PayloadAction<string>) => {
      state.errorBlog = payload;
    },
    setBlogs: (state: IBlogsState, { payload }: PayloadAction<IBlog[]>) => {
      state.blogs = payload;
    },
    setSelectedBlog: (state: IBlogsState, { payload }: PayloadAction<IBlog | null>) => {
      state.selectedBlog = payload;
    },
  },
});

export const blogsActions = blogsSlice.actions;

export const blogsReducer = blogsSlice.reducer;

export const getAllBlogs = (): AppThunk => {
  return async (dispatch, getState) => {
    dispatch(blogsActions.setLoading(true));
    dispatch(blogsActions.setErrorBlog(''));

    try {
      const { loginStore } = getState();
      const { account } = loginStore;

      const response = await fetch(`https://travocding-blogs.s3.us-east-1.amazonaws.com/front/${account?.name}/blogs.json`);
      const data = await response.json();

      setTimeout(() => {
        //dispatch(blogsActions.setBlogs(hardcodedBlogs?.sort((a: IBlog, b: IBlog) => new Date(b.createdDate || '').getTime() - new Date(a.createdDate || '').getTime())));
        dispatch(blogsActions.setBlogs(data?.sort((a: IBlog, b: IBlog) => new Date(b.createdDate || '').getTime() - new Date(a.createdDate || '').getTime())));
        dispatch(blogsActions.setLoading(false));
      }, 1000);
    } catch (error) {
      console.error(error);
      dispatch(blogsActions.setError(error instanceof Error ? error.message : String(error)));
      dispatch(blogsActions.setLoading(false));
    }
  };
};

export const getBlogById = (id: number): AppThunk => {
  return async (dispatch, getState) => {
    dispatch(blogsActions.setErrorBlog(''));
    dispatch(blogsActions.setSelectedBlog(null));
    dispatch(blogsActions.setLoadingBlog(true));


    try {
      const { loginStore } = getState();
      const { account } = loginStore;

      const response = await fetch(`https://travocding-blogs.s3.us-east-1.amazonaws.com/front/${account?.name}/blogs.json`);
      const data = await response.json();

      setTimeout(() => {
        //const blog = hardcodedBlogs.find((b: IBlog) => b.id === id);
        const blog = data.find((b: IBlog) => b.id === id);
        if (!blog) {
          dispatch(blogsActions.setErrorBlog('404'));
        } else {
          dispatch(blogsActions.setSelectedBlog(blog));
        }
        dispatch(blogsActions.setLoadingBlog(false));
      }, 1000);
    } catch (error) {
      console.error(error);
      dispatch(blogsActions.setErrorBlog(error instanceof Error ? error.message : String(error)));
      dispatch(blogsActions.setLoadingBlog(false));
    }
  };
};

